import { render, staticRenderFns } from "./HomeProjectRail.vue?vue&type=template&id=803c0620"
import script from "./HomeProjectRail.vue?vue&type=script&lang=js"
export * from "./HomeProjectRail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports